import getProjects from "./getProjects";

export default {
  getProjects
}